export const TICKET_CATEGORIES = [
  { value: "electrical", key: "electrical" },
  { value: "plumbing", key: "plumbing" },
  { value: "internet", key: "internet" },
  { value: "appliances", key: "appliances" },
  { value: "commonAreas", key: "commonAreas" },
  { value: "other", key: "other" },
] as const

export type TicketCategoryValue = (typeof TICKET_CATEGORIES)[number]["value"]

// Helper function to get translated categories
export const getTranslatedTicketCategories = (t: (key: string) => string) => {
  return TICKET_CATEGORIES.map((category) => ({
    value: category.value,
    label: t(category.key),
  }))
}
